/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_DescriptionInputs */

const en_carrier_notices_description = /** @type {(inputs: Carrier_Notices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage customer-facing carrier warnings shown during public checkout. Notices are warning-only and do not block carrier selection.`)
};

const es_carrier_notices_description = /** @type {(inputs: Carrier_Notices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administra advertencias de transportistas visibles para clientes durante el checkout publico. Los avisos solo informan y no bloquean la seleccion del transportista.`)
};

/**
* | output |
* | --- |
* | "Manage customer-facing carrier warnings shown during public checkout. Notices are warning-only and do not block carrier selection." |
*
* @param {Carrier_Notices_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_description = /** @type {((inputs?: Carrier_Notices_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_description(inputs)
	return es_carrier_notices_description(inputs)
});